import { render, staticRenderFns } from "./DetailsTabs.vue?vue&type=template&id=83b01bf8&"
import script from "./DetailsTabs.vue?vue&type=script&lang=js&"
export * from "./DetailsTabs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\takaj\\Documents\\COFOUNDRY\\okinus-ui\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('83b01bf8')) {
      api.createRecord('83b01bf8', component.options)
    } else {
      api.reload('83b01bf8', component.options)
    }
    module.hot.accept("./DetailsTabs.vue?vue&type=template&id=83b01bf8&", function () {
      api.rerender('83b01bf8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/features/leases/components/DetailsTabs.vue"
export default component.exports